// 역할 : SDK 카테고리 헤더 제목 표시
import { useTranslation } from 'react-i18next';

import { getCategoryById } from '../../../config/menu.config';
import { useRegion } from '../../hooks/useRegion';

interface SDKCategoryTitleProps {
  categoryName: string;
}

export const CategoryTitle = ({ categoryName }: SDKCategoryTitleProps) => {
  const { t } = useTranslation();
  const { isOverseas } = useRegion();

  // 설정에서 카테고리 정보를 가져와서 i18n 키 반환
  const getCategoryI18nKey = (sdkId: string): string => {
    const categoryConfig = getCategoryById(sdkId);
    return categoryConfig ? categoryConfig.titleKey : sdkId;
  };

  const getDisplayTitle = () => {
    // 라이선스 페이지
    if (categoryName === 'license') {
      return t('license.title');
    }

    // 해외향 모드에서 Hcell SDK는 "Spreadsheet SDK"로 표시
    if (isOverseas && categoryName === 'hcell') {
      return t('sidebar.categories.hcellOverseas');
    }

    const i18nKey = getCategoryI18nKey(categoryName);
    return typeof i18nKey === 'string' && i18nKey.includes('.') ? t(i18nKey) : categoryName;
  };

  return <h1 className='text-2xl font-bold text-black'>{getDisplayTitle()}</h1>;
};

export default CategoryTitle;
